import { Autocomplete, Button, Card, CardContent, Grid,Divider, MenuItem, TextField, Typography, } from '@mui/material'
import React, { useState, useEffect } from 'react'
import ArrowBackSharpIcon from '@mui/icons-material/ArrowBackSharp';
import axios from 'axios';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import api from '../../../utils/Url';
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from '../../../ToastApp';

type Props = {};

const DesignationMasterAdd = (props: Props) => {
    let navigate = useNavigate();
    const { i18n, t } = useTranslation();
  
  const [option, setOption] = useState([{ value: "-1", label:t("text.selectDet") }]);

    useEffect(() => {
        getDeptbyId();
    }, [])
    const[toaster,setToaster]=useState(false);
    const getDeptbyId = () => {
        const collectData = {
            "dept_id": -1,
            "isActive": true,
            "user_ID": localStorage.getItem("useR_ID"),
        };
        api
          .post(`Department/GetDepartmentmaster`, collectData)
          .then((res) => {
            const arr:any = [];
            console.log("result" + JSON.stringify(res.data.data));
            for (let index = 0; index < res.data.data.length; index++) {
              arr.push({
                label: res.data.data[index]["dept_name"],
                value: res.data.data[index]["dept_id"]
              });
            }
            setOption(arr);
          });
      };

    const validationSchema = Yup.object({
      
        designation_name: Yup.string().test(
        'required', 
        t('text.reqdesignname'), 
        function (value:any) {
          return value && value.trim() !== ''; 
        }
      ),
      dept_id: Yup.string().test(
        'required', 
        t('text.reqdept_id'), 
        function (value:any) {
          return value && value.trim() !== ''; 
        }
      ),
    });
  
    const formik = useFormik({
      initialValues: {
        designation_id: -1,
        designation_name: "",
        short_name: "",
        sortOrder: 0,
        user_ID:localStorage.getItem("useR_ID"),
        isActive: true,
        dept_id: "",
      },
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        const response = await api.post(
           `Designation/AddUpdateDesignationmaster`,
          values
          );
            if (response.data.isSuccess) {
              setToaster(false);
              toast.success(response.data.mesg);
              navigate('/master/DesignationMaster');
            } else {
              setToaster(true);
              toast.error(response.data.mesg);
            }
    
    }
  });
  
    const requiredFields = ['dept_id','designation_name']; 
  
    const back = useNavigate();
  
    return (
      <div>
        <div
          style={{
            padding: "-5px 5px",
            backgroundColor: "#ffffff",
            borderRadius: "5px",
            border: ".5px solid #FF7722",
            marginTop:"3vh"
          }}
        >
          <CardContent>
            <Typography
              variant="h5"
              textAlign="center"
              style={{ fontSize: "18px", fontWeight: 500 }}
            >
              {t("text.createddesigMAster")}
            </Typography>
  
            <Grid item sm={4} xs={12}>
              <Typography style={{ marginTop: "-75px" }}>
                <Button
                  type="submit"
                  onClick={() => back(-1)}
                  variant="contained"
                  style={{
                    marginBottom: 15,
                    marginTop: "45px",
                    backgroundColor: "blue",
                    width: 20,
                  }}
                >
                  <ArrowBackSharpIcon />
                </Button>
              </Typography>
            </Grid>
            <Divider />
            <br />
            <form onSubmit={formik.handleSubmit}>
            {toaster===false ?"":<ToastApp/>}
              <Grid item xs={12} container spacing={2}>
              <Grid xs={12} sm={4} item>
                
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={option}
                  fullWidth
                  value={
                    option.find(
                      (option) => option.value === formik.values.dept_id
                    ) || null
                  }
                  size="small"
                  onChange={(event, newValue) => {
                    if(newValue==null)
                    {
                      formik.setFieldValue("dept_id","");
                    }
                    else {
                      console.log(newValue?.value);
                    formik.setFieldValue("dept_id", newValue?.value);
             formik.setFieldTouched("dept_id", true); 
                      formik.setFieldTouched("dept_id", false); 
                    }
                  
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label={
                      <span>
                        {t("text.selectDet")} {" "}
                        {requiredFields.includes('dept_id') && (
                          <span style={{ color: formik.values.dept_id ? 'green' : 'red' }}>*</span>
                        )}
                      </span>
                    } />
                  )}
                />
                 {formik.touched.dept_id && formik.errors.dept_id ? (
                    <div style={{color:"red", margin:"5px"}}>{formik.errors.dept_id}</div>
                  ) : null}
              </Grid>
                <Grid item lg={4} xs={12}>
                  <TextField
                    id="designation_name"
                    name="designation_name"
                    label={
                      <span>
                        {t("text.enterDesName")}{" "}{requiredFields.includes('designation_name') && (
                          <span style={{ color: formik.values.designation_name ? 'green' : 'red' }}>*</span>
                        )}
                      </span>
                    }
                    value={formik.values.designation_name}
                    placeholder={t("text.enterDesName")}
                    size="small"
                    fullWidth
                    style={{
                      backgroundColor: 'white',
                      borderColor: formik.touched.designation_name && formik.errors.designation_name ? 'red' : 'initial',
                    }}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.designation_name && formik.errors.designation_name ? (
                    <div style={{color:"red", margin:"5px"}}>{formik.errors.designation_name}</div>
                  ) : null}
                </Grid>
  
                <Grid item lg={4} xs={12}>
                  <TextField
                    id="short_name"
                    name="short_name"
                    label={t("text.entershortCode")}
                    value={formik.values.short_name}
                    placeholder={t("text.entershortCode")}
                    size="small"
                    fullWidth
                    style={{ backgroundColor: "white" }}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </Grid>
  
                <Grid item lg={6} sm={6} xs={12}>
                  <Grid>
                    <Button
                      type="submit"
                      fullWidth
                      style={{
                        backgroundColor: "#059669",
                        color: "white",
                        marginTop: "10px",
                      }}
                    >
                       {t("text.save")}
                    </Button>
                  </Grid>
                </Grid>
                <Grid item lg={6} sm={6} xs={12}>
                  <Button
                    type="reset"
                    fullWidth
                    style={{
                      backgroundColor: "#F43F5E",
                      color: "white",
                      marginTop: "10px",
                    }}
                    onClick={(e) => formik.resetForm()}
                  >
                    {t("text.reset")}
                  </Button>
                </Grid>
              </Grid>
            </form>

          </CardContent>
        </div>
      </div>
    );
};

export default DesignationMasterAdd;